import React from 'react';

import { Modal, Button } from 'react-bootstrap'

import { infoIcon } from '../../../img/font_awesome/font_awesome'

export default class InfoBox extends React.Component {

   handleCloseClick = () => {
      this.props.hideInfoBox();
   }

   render() {
      let title = ""

      if (this.props.title) {
         title = this.props.title;
      }

      return (
         <Modal show={this.props.show} onHide={this.handleCloseClick} size="lg" centered>
       
            <Modal.Header closeButton >
               <Modal.Title style={{color: '#3674AB'}}>{infoIcon} {title}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ fontWeight: 'bold',  fontSize: 20}}>
               {this.props.message}
            </Modal.Body>
            <Modal.Footer>
               <Button variant="secondary" onClick={this.handleCloseClick}>OK</Button>
            </Modal.Footer>
         </Modal>
      )
   }
}